<template>
  <div>
    <div class="disbursement__single outer-container">
      <div class="panel">
        <div class="panel__header">
          <disburse-options></disburse-options>
        </div>
        <div class="panel__content panel__content--grey panel__content">
          <div v-if="awaitingFile">
            <div class="form__header text-center">
              <p>Prepare your transfers in a spreadsheet and upload them here for bulk proccessing.</p>
            </div>
            <!--bulk transfer-->
            <form action class="form disburse-form disburse-form__bulk">
              <div class="form__item form__item--column">
                <br>
                <div class="form__item">
                <label for="disburseSource" class="form__label--span form--left">
                  Send
                  <span>from</span>
                </label>
                <div class="select form--right">
                  <select
                    name="disburse-source"
                    id="disburseSource"
                    class="select__input"
                    v-model="selectedBalance"
                    v-validate="'required'"
                    @change="selectedSource(selectedBalance)"
                  >
                    <option value disabled>Select wallet balance to disburse from</option>
                    <option
                      v-for="option in walletList"
                      v-bind:value="option"
                    >Balance - {{ option.currencyCode }} {{option.currencyBalance | numeralize('0,0.00') }}</option>
                  </select>
                  <div class="select__icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="6"
                      height="10"
                      viewBox="0 0 6 10"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
                <div class="panel__file-upload" style="padding-left: 5px;" v-if="balanceSelected">
                  <div class="panel__file-upload__icon">
                    <svg
                      class
                      width="40px"
                      height="40px"
                      enable-background="new 0 0 585.918 585.918"
                      version="1.1"
                      viewBox="0 0 585.918 585.918"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m357.4 535.32c0.776 0.052 1.542 0.114 2.329 0.114h177.39c20.75 0 37.627-16.883 37.627-37.627v-411.22c0-20.743-16.877-37.628-37.627-37.628h-177.39c-0.781 0-1.553 0.07-2.329 0.118v-49.087l-346.22 46.206v492.31l346.22 47.401v-50.593zm0-174.11h57.407v21.511h-57.407v-21.511zm0-2.688v-21.905h57.407v21.905h-57.407zm0-24.593v-25.13h57.407v25.13h-57.407zm0-27.818v-28.131h57.407v28.131h-57.407zm0-30.425v-26.798h57.407v26.798h-57.407zm0-29.097v-26.798h57.408v26.798h-57.408zm2.33-176.12h177.39c8.893 0 16.125 7.236 16.125 16.126v411.22c0 8.888-7.232 16.127-16.125 16.127h-177.39c-0.792 0-1.563-0.121-2.329-0.243v-128.69h59.706v-5e-3h130.67v-170.2h-0.117v-26.409h-134v5e-3h-56.262v-117.7c0.766-0.117 1.533-0.235 2.33-0.235zm185.36 149.31v162.53h-25.092v-154.68h-17.228v154.68h-14.353v-138.79h-17.228v138.79h-12.642v-123.1h-17.229v123.1h-24.21v-162.53h127.98zm-63.276-2.289v-26.796h63.55v24.108h-0.273v2.688h-63.277zm-2.299 0h-63.549v-26.796h63.544v26.796h5e-3zm-380.84 104.04c7.126 0.127 15.097-1.407 19.812-3.327l3.614 19.927c-4.399 2.226-14.268 4.462-26.974 4.121-35.293-0.94-53.019-24.741-53.019-55.626 0-36.998 24.302-58.227 55.329-59.043 12.263-0.329 21.67 2.097 25.933 4.328l-4.882 20.282c-4.869-2.092-11.588-3.969-19.969-3.827-18.528 0.309-32.715 12.422-32.715 36.824-1e-3 21.957 12.051 35.991 32.871 36.341zm66.1 22.583c-12.567-0.341-24.829-4.03-30.909-7.711l4.956-21.087c6.595 3.634 16.809 7.36 27.425 7.537 11.556 0.2 17.722-4.683 17.722-12.225 0-7.219-5.321-11.366-18.707-16.394-18.228-6.667-29.961-17.096-29.961-33.555 0-19.32 15.455-34.518 41.512-35.2 12.683-0.339 22.111 2.179 28.903 5.134l-5.771 21.399c-4.569-2.176-12.633-5.315-23.625-5.134-10.884 0.178-16.125 5.364-16.125 11.31 0 7.307 6.212 10.482 20.609 16.042 19.99 7.52 29.523 18.271 29.523 34.784-8e-3 19.635-14.79 35.919-45.552 35.1zm123.29 1.491l-32.086-0.829-37.772-118.47 29.103-0.748 14.551 50.26c4.128 14.224 7.895 27.957 10.772 42.97l0.548 0.01c3.063-14.436 6.874-28.725 11.058-42.528l15.772-52.055 30.277-0.769-42.223 122.16z"
                      ></path>
                    </svg>
                  </div>
                  <div>
                    <input
                      ref="file"
                      type="file"
                      placeholder="Upload CSV file"
                      id="csv_file"
                      name="csv"
                      required="true"
                      extension="csv"
                      aria-invalid="true"
                      style="padding-left: 9px;"
                      @change="fileUpdate()"
                    >
                    <!--<input type="file" class="form-control user-error" placeholder="Upload CSV file" id="csv_file" name="csv" required="true" extension="csv" aria-invalid="true">-->
                    <!--<button class="btn btn&#45;&#45;default btn&#45;&#45;sm" ref="file" type="">Upload csv</button>-->
                  </div>
                </div>
                <div>
                  <span class="panel__file-upload__info">
                    <a
                      href="https://s3-eu-west-1.amazonaws.com/moneywave-resources/downloads/disburse_sample.csv"
                      class="btn btn-link"
                    >Get Sample Bulk Upload File</a>
                  </span>
                  <span class="panel__file-upload__info" style="padding-top: 15px;">
                    <a href="#" class="btn btn-link" data-toggle="modal"
                data-target="#BankListModal">Banks List</a>
                  </span>
                </div>
              </div>

              <div class="form__item disburse-form__submit" v-if="enableActions">
                <!--<a class="btn btn&#45;&#45;primary btn&#45;&#45;block" data-toggle="modal" data-target="#reviewBulkPaymentModal" @click="handleUpload()">REVIEW AND SEND</a>-->
                <a class="btn btn--primary btn--block" @click="handleUpload()">REVIEW AND SEND</a>
              </div>
            </form>
          </div>
          <div v-if="!awaitingFile">
            <form action class="form disburse-form disburse-form__single">
              <!-- <div class="form__item">
                <label for="disburseSource" class="form__label--span form--left">
                  Send
                  <span>from</span>
                </label>
                <div class="select form--right">
                  <select
                    name="disburse-source"
                    id="disburseSource"
                    class="select__input"
                    v-model="selectedBalance"
                    v-validate="'required'"
                    @change="selectedSource(selectedBalance)"
                  >
                    <option value disabled>Select wallet balance to disburse from</option>
                    <option
                      v-for="option in walletList"
                      v-bind:value="option"
                    >Balance - {{ option.currencyCode }} {{option.currencyBalance}}</option>
                  </select>
                  <div class="select__icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="6"
                      height="10"
                      viewBox="0 0 6 10"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div> -->
              <div class="form__item">
                <label for="beneficiarySource" class="form__label--span form--left">
                  Lock
                  <span>Code</span>
                </label>
                <div class="select form--right">
                  <input
                    type="password"
                    name="code"
                    placeholder="Enter Code"
                    v-model="dataObj.lockCode"
                    id
                    class="form__input input"
                    data-vv-id="1"
                    aria-required="true"
                    aria-invalid="false"
                  >
                </div>
              </div>
              <div class="form__item">
                <label for="beneficiarySource" class="form__label--span form--left">
                  Batch
                  <span>Name</span>
                </label>
                <div class="select form--right">
                  <input
                    type="text"
                    name="batch"
                    placeholder="Enter Batch Name"
                    v-model="dataObj.batchName"
                    id="i"
                    class="form__input input"
                    data-vv-id="1"
                    aria-required="true"
                    aria-invalid="false"
                  >
                </div>
              </div>
              <div class="form__item">
                <label for="beneficiarySource" class="form__label--span form--left">
                  Total
                  <span>Charge</span>
                </label>
                <div class="select form--right">
                  <input
                    type="text"
                    name="name"
                    readonly
                    v-model="dataObj.totalCharge"
                    id="f"
                    class="form__input input"
                    data-vv-id="1"
                  >
                </div>
              </div>
              <!--<div v-if="isLoading">-->
              <!--<div class="row" id="resolved-accounts-list-loading">-->
              <!--<div class="col-md-12 text-xs-center">-->
              <!--<i class="fa fa-refresh fa-spin"></i> Processing all accounts. Please wait...-->
              <!--</div>-->
              <!--</div>-->
              <!--<table class="table table-bordered table-striped" id="resolved-accounts-list"></table>-->
              <!--<div class="form-actions row">-->
              <!--<div class="row">-->
              <!--<div class="col-md-3">&nbsp;</div>-->
              <!--<div class="col-md-offset-3 col-md-9">-->
              <!--<button type="submit" id="bulk_disburse_btn" style="display: none;" class="btn btn-primary btn-rounded w-min-sm m-b-0-25 waves-effect waves-light">-->
              <!--Proceed with Disburse-->
              <!--</button>-->
              <!--<a href="https://moneywave-admin.herokuapp.com/wallets/14354/disburse" class="btn btn-secondary btn-rounded w-min-sm m-b-0-25 waves-effect waves-light">-->
              <!--Cancel-->
              <!--</a>-->
              <!--</div>-->
              <!--</div>-->
              <!--</div>-->
              <!--</div>-->
            </form>
            <hr>
            <div class="table">
              <!-- Table body -->
              <div
                class="table__section table__section--body"
                v-for="(bulkTransfer, index) in bulkTransferData.data"
              >
                <!-- table row -->
                <div class="table__row">
                  <div class="table__data" :id="index">
                    <input type="checkbox" :id="index" :value="index" v-model="selected">
                    <!--<label :for="bulkTransfer.accountNumber"> {{bulkTransfer.accountNumber}} </label>-->
                  </div>
                  <!-- table data -->
                  <div class="table__data">
                    <div class="table__data--bold">
                      <small class="table__data--result">
                        {{bulkTransfer.accountNumber}}
                        <span v-if="bulkTransfer.x_recipient_name"> | {{ bulkTransfer.x_recipient_name }}</span>
                      </small>
                    </div>
                  </div>
                  <!-- table data -->
                  <div class="table__data">
                    <span class="table__data--default">{{bulkTransfer.resolveName}}</span>
                  </div>
                  <!-- table data -->
                  <div class="table__data">
                    <span class="table__data--default">{{bulkTransfer.bank}}</span>
                  </div>
                  <!-- table data -->
                  <div class="table__data">
                    <div class="table__data--default">{{ bulkTransfer.amount }}</div>
                  </div>

                  <!-- table data -->
                  <div class="table__data">
                    <div class="table__data--default">{{bulkTransfer.narration}}</div>
                  </div>
                </div>
                <div class="table__row spacer"></div>
              </div>
            </div>
            <button class="btn btn--primary" id="submitbtn" @click="handleSubmission()">Submit Batch</button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="reviewBulkPaymentModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="reviewBulkPaymentModal"
    >
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--xlg" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              Payment
              <span>Confirmation</span>
            </div>
            <!-- Modal close button -->
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <path
                  fill="#C0C6D8"
                  fill-rule="nonzero"
                  d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z"
                ></path>
              </svg>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body--pad">
            <div class="disburse__confirmation">
              <div class="disburse__confirmation__title">
                You are about to send
                <span class>$12,800</span> to Tammy 54 recipients
              </div>
              <div class="disburse__confirmation__breakdown">
                <!--amount disbursed-->
                <div class="breakdown__item">
                  <div class="breakdown__item__name">Payment amount</div>
                  <div class="breakdown__item__result">$ 12,348,232</div>
                </div>

                <!--funding source-->
                <div class="breakdown__item">
                  <div class="breakdown__item__name">Funding source</div>
                  <div class="breakdown__item__result">Wallet (USD)</div>
                </div>

                <!--recipient-->
                <div class="breakdown__item">
                  <div class="breakdown__item__name">54 Transfers</div>
                  <div class="breakdown__item__result">
                    <a href class="link">See List</a>
                  </div>
                </div>
              </div>

              <!--confirm disbursement-->
              <div class="disburse__confirmation__submit">
                <button class="btn btn--primary btn--block">CONFIRM AND SEND</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="BankListModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="BankListModal"
    >
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--lg" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              <span class="time-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  width="512px"
                  height="512px"
                  viewBox="0 0 612 612"
                  style="enable-background:new 0 0 612 612;"
                  xml:space="preserve"
                  class="icon--sm"
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                        <path
                          d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              Banks - Name, Tag, Code
            </div>
            <!-- Modal close button -->
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <path
                  fill="#C0C6D8"
                  fill-rule="nonzero"
                  d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z"
                ></path>
              </svg>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body" style="height: 450px; overflow-y:scroll">
            <br>
            <div class >
              <form class="form disburse-form" @submit.prevent="handleBankList(selectedCountry, 1)">
                <div class="select form--right">
                  <select
                    name="Country"
                    id="Country"
                    class="select__input"
                    v-model="selectedCountry"
                    v-validate="'required'"
                    @change="handleBankList(selectedCountry, 0)"
                  >
                    <option value disabled>Select a country</option>
                    <option
                      v-for="option in countryLists"
                      v-bind:value="option.countryTag"
                    >{{ option.countryName }}</option>
                    <!-- <option value="NG">Nigeria</option>
                    <option value="KE">Kenya</option>
                    <option value="GH">Ghana</option> -->
                  </select>
                  <div class="select__icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="6"
                      height="10"
                      viewBox="0 0 6 10"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                      ></path>
                    </svg>
                  </div>
                </div>

              </form>
              <br>
              <div v-if="!CountrySelected" class="panel__empty">
                <div class="panel__empty__text">Select a country to view supported destinations <br> Banks and Mobile Money. </div>
              </div>
              <div class="table" v-if="CountrySelected">
              <!-- Table body -->
              <div class="table__section table__section--body" v-for="(data, index) in listData">
                <!-- table row -->
                <div class="table__row">
                  <!-- table data -->
                  <div class="table__data">
                    <div class="table__data--bold">
                      <small class="table__data--result">{{data.bankName}}</small>
                    </div>
                  </div>
                  <!-- table data -->
                  <div class="table__data">
                    <span class="">{{data.tag}}</span>
                  </div>
                  <!-- table data -->
                  <div class="table__data">
                    <div class="">{{ data.code }}</div>
                  </div>
                </div>
                <div class="table__row spacer"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal__footer">
            <button v-if="true" class="btn btn--primary" id="submitbtn" @click="handleBankList(selectedCountry, 1)">Download</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade in"
      id="createModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createModal"
      style="display: block;"
      v-if="uploadDone"
    >
      <div class="modal__dialog modal__dialog--xlg">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
                          <span class="time-icon">
                            <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    version="1.1"
                                    id="Capa_1"
                                    x="0px"
                                    y="0px"
                                    width="512px"
                                    height="512px"
                                    viewBox="0 0 612 612"
                                    style="enable-background:new 0 0 612 612;"
                                    xml:space="preserve"
                                    class="icon--sm"
                            >
                  <g>
                    <g>
                      <g>
                        <path
                                d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#576ae6"
                                fill="#576ae6"
                        ></path>
                        <path
                                d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#576ae6"
                                fill="#576ae6"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
                          </span>
              Batch Response
            </div>
            <button
                    type="button"
                    class="close btn btn--default btn--sm"
                    data-dismiss="modal"
                    aria-label="Close"
            >
              <span>Close</span>
            </button>
          </div>

          <div class="modal__body modal__body--pad">
            <div class="disburse__result text-center">
              <div v-if="uploadSuccessful">
                <!--success icon-->
                <div class="result-img">
                  <svg
                    class="icon icon--custom-big"
                    enable-background="new 0 0 50 50"
                    version="1.1"
                    viewBox="0 0 50 50"
                    xml:space="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                    <polyline
                      points="38 15 22 33 12 25"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></polyline>
                  </svg>
                </div>
                <p class="disburse__result__success success-text">{{ message }}</p>
                <button
                  class="btn btn--primary"
                  @click="triggerPageLoad()"
                >Upload another batch</button>
                <button
                  class="btn btn--default"
                  @click="triggerRefresh()"
                >Check batch status</button>
              </div>

              <div v-if="uploadFailed">
                <div class="result-img">
                  <svg
                    enable-background="new 0 0 50 50"
                    version="1.1"
                    viewBox="0 0 50 50"
                    xml:space="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon--custom-big"
                  >
                    <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                    <polyline
                      points="16 34 25 25 34 16"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></polyline>
                    <polyline
                      points="16 16 25 25 34 34"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    ></polyline>
                  </svg>
                </div>
                <p
                  v-for="error in uploadErrors"
                  class="disburse__result__error error-text"
                >{{error}}</p>
                <button
                  data-dismiss="modal"
                  aria-label="Close"
                  class="btn btn--primary"
                  @click="triggerPageLoad('retry')"
                >Retry transfer</button>
                <button
                  class="btn btn--default"
                  @click="triggerRefresh()"
                >Check Batch status</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DisburseOptions from "@/components/partials/DisburseOptions";
import {
  resolveBulk,
  disburseQueue,
  getBanksList,
  getCurrencyName
} from "../../utils/wallet-transactions/transferService";
import { resolveAccountName } from "../../utils/helpers/utilitiesService";

export default {
  beforeRouteEnter(to, from, next) {
    let permission = window.localStorage.getItem('permissions');
    permission = (permission) ? JSON.parse(window.localStorage.getItem('permissions')) : [];

    if (!permission.includes('wallet.disburse')) {
      next({
        name: 'overview',
        query: { redirectFrom: to.fullPath },
      })
    } else next();
  },

  created() {
    this.countryList();
  },

  beforeRouteUpdate(to, from, next) {
    this.$Progress.start();
    // this.handleWalletFundingHistory();
    this.$Progress.finish();
    // don't forget to call next()
    next();
  },

  data() {
    return {
      showModal: false,
      file: "",
      awaitingFile: true,
      isLoading: true,
      bulkTransferData: [],
      uploadErrors: [],
      selectedBalance: {},
      dataObj: {
        batchName: "",
        lockCode: "",
        totalCharge: "",
        sender: window.localStorage.getItem("merchantName"),
        currency: "",
        ref: "",
        recipients: {},
        walletUref: ""
      },
      selected: [],
      balanceSelected: false,
      selectedCountry: '',
      CountrySelected: false,
      listData: [],
      countryLists: [],
      uploadDone: false,
      uploadFailed: false,
      uploadSuccessful: false,
      message: '',
      code: '',
    };
  },
  components: {
    "disburse-options": DisburseOptions
  },
  watch: {
    // call again the fetch method if the route changes
    // uncomment if not working
    // bulkTransferData: function() {
    //   this.bulkTransferData = this.bulkTransferData;
    // },

    '$route': 'handleTransferHistory'
  },
  computed: {
    enableActions: {
      get() {
        return this.$store.state.enableActions;
      },
    },
    walletList() {
      let a = [];
      if(Object.keys(window.localStorage.getItem("walletList")).length > 0) {
        Object.keys(
          JSON.parse(window.localStorage.getItem("walletList"))
        ).forEach(response => {
          {
            a.push(
              JSON.parse(window.localStorage.getItem("walletList"))[response]
            );
          }
        });
      }
      return a;
    },
  },
  methods: {
    countryList(){
      let b = [];
      getCurrencyName().then((response) => {
        Object.keys(response.data.data).forEach((resp) => {
          b.push(response.data.data[resp]);
        })
      })
      .catch((error) => {
        console.log(error);
      })
      this.countryLists = b;
    },
    // bank code = false and amount = 0
    fileUpdate() {
      this.file = this.$refs.file.files[0];
    },
    selectedSource(wallet) {
      this.dataObj.currency = wallet.currencyCode;
      this.dataObj.walletUref = wallet.currencyUref;
      this.balanceSelected = true;
    },
    downloadFile(text){
          window.open(text, "_blank");
    },
    handleBankList(country, download) {
      this.CountrySelected = true
      this.$Progress.start();
      getBanksList(country, download).then((response) => {
        this.$Progress.finish();
        if(!download){
          this.listData = response.data.response;
        }
        else{
          const downloadparts = response.data.response.file.split('file/');
          if (response.data.file.includes('staging')) {
            this.downloadFile(`https://staging.moneywaveapp.com/admin/v1/file/${response.data.file.split('file/')[1]}`);
          } else {
            this.downloadFile(`https://frontend.moneywaveapp.com/admin/v1/file/${response.data.file.split('file/')[1]}`);
          }
        }
      })
      .catch((error) => {
        this.$Progress.fail();
        console.log(error);
      })
    },
    handleUpload() {
      this.$Progress.start();
      resolveBulk(this.file, this.dataObj.currency)
        .then(response => {
          if (response.status === 200) {
            this.isLoading = false;
            this.$Progress.finish();
            this.awaitingFile = false;
            this.bulkTransferData = response.data;
            let counter = 0;
            Object.keys(this.bulkTransferData.data).forEach(response1 => {
              if (
                this.bulkTransferData.data[response1].amount !== 0 &&
                this.bulkTransferData.data[response1].bankcode !== false
              ) {
                this.selected.push(counter);
              }
              counter = counter + 1;
            });
            this.dataObj.totalCharge = this.bulkTransferData.chargeAmount;
            Object.keys(this.bulkTransferData.data).forEach((response) => {
              if (response == 0) this.bulkTransferData.data[response].resolveName = 'Resolve name';
              // delete if not working
              else if (this.selected.includes(Number(response))) this.bulkTransferData.data[response].resolveName = 'Resolving';
              else this.bulkTransferData.data[response].resolveName = '';
            })
            let count = this.selected;
            Object.keys(this.bulkTransferData.data).forEach((response) => {
              if (this.selected.includes(Number(response))) {
                let obj = {
                  accountNumber: this.bulkTransferData.data[response].accountNumber,
                  accountBankCode: this.bulkTransferData.data[response].bankcode
                };
                resolveAccountName(obj).then((resp) => {
                  this.bulkTransferData.data[response].resolveName = resp.data.accountName;
                  let data = this.bulkTransferData.data[response];
                  // very important for the auto update;l
                  this.$set(this.bulkTransferData.data, response, {
                    ...data,
                    resolveName: resp.data.accountName,
                    });
                })
                .catch((error) => {
                  console.log(error);
                  this.bulkTransferData.data[response].resolveName = 'Not Resolved';
                  var index = count.indexOf(Number(response));
                  if (index !== -1) count.splice(index, 1);
                });
              }
            })
          }
        })
        .catch(error => {
          this.$Progress.fail();
          console.log(error);
        });
    },
    handleSubmission() {
      this.$Progress.start();
      this.dataObj.ref = `BATCH${Math.random()
        .toString()
        .slice(2, 10)}.${Math.random()
        .toString()
        .slice(2, 10)}`;
      let count = 0;
      Object.keys(this.bulkTransferData.data).forEach(response => {
        if (this.selected.includes(Number(response))) {
          this.dataObj.recipients[count] = this.bulkTransferData.data[response];
          count = count + 1;
        }
      });
      disburseQueue(this.dataObj)
        .then(response => {
          this.$Progress.finish();
          this.uploadDone = true;
          if (response.data.status === "success") {
            this.uploadSuccessful = true;
            this.uploadFailed = false;
            this.message = response.data.data.msg || 'Batch successfully uploaded';
            this.code = response.data.data.code || null;
          } else {
            this.uploadSuccessful = false;
            this.uploadFailed = true;
            this.$Progress.fail();
            this.uploadErrors.push('Upload Failed');
          }
        })
        .catch(error => {
          this.uploadDone = true;
          this.uploadSuccessful = false;
          this.uploadFailed = true;
          this.uploadErrors.push(error.response.data.message || error.response.data.error.message);
          this.$Progress.fail();
          console.log(error);
        });
    },
    triggerPageLoad(request){
      if (request === 'retry') {
        this.uploadDone = false;
        this.uploadSuccessful = false;
        this.uploadFailed = true;
        this.uploadErrors = [];
      } else location.reload();
    },
    triggerRefresh(){
      if (this.code === 'APPROVAL_REQUIRED') {
        this.$router.push({
          name: "awaiting-approval",
        });
      } else {
        this.$router.push({
          name: "batch-transfers",
        });
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/disbursement/BulkTransfers.vue